import { defineStore } from 'pinia'

interface User {
  sent: boolean
  expiresAfter: number
  sentTo: string
  name: string
  username: string
  avatar: string
}

export const useVerifiedUser = defineStore('verifiedUser', {
  state: () => ({
    user: {} as User
  }),
  getters: {
    getUser(): User {
      return this.user
    }
  },
  actions: {
    setUser(userData: User): void {
      console.log(userData)
      this.user = userData
    },
    clearUser(): void {
      this.user = {} as User
    }
  },
  persist: {
    key: 'verified-user',
    storage: localStorage,
    paths: ['user']
  }
})
